import React from 'react';

interface Tag {
  name: string;
  count: number;
}

interface TagCloudProps {
  tags: Tag[];
  selectedTags: string[];
  onTagClick: (tag: string) => void;
}

export function TagCloud({ tags, selectedTags, onTagClick }: TagCloudProps) {
  // Ordena as tags por contagem (mais populares primeiro)
  const sortedTags = [...tags].sort((a, b) => b.count - a.count);

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Tags Populares</h3>
      <div className="flex flex-wrap gap-2">
        {sortedTags.map((tag) => (
          <button
            key={tag.name}
            onClick={() => onTagClick(tag.name)}
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm transition-colors ${
              selectedTags.includes(tag.name)
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {tag.name}
            <span className={`ml-2 text-xs ${
              selectedTags.includes(tag.name)
                ? 'text-blue-100'
                : 'text-gray-500'
            }`}>
              {tag.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
